$(function () {
  let rootEle = document.getElementById("root");
  rootEle.style.zoom = "normal"; //避免zoom尺寸叠加
  let scale = rootEle.clientWidth / 1080;
  rootEle.style.zoom = scale;
  window.addEventListener("resize", function () {
    rootEle.style.zoom = "normal";
    let scale = rootEle.clientWidth / 1080;
    rootEle.style.zoom = scale;
  });

  $(".selectl span").click(function () {
    $(this).addClass("on").siblings().removeClass("on");
    $(this).parent().parent().find("span#price1").text($(this).data("price"));
    $(this).parent().parent().find("span#price2").text($(this).data("compare"));
    let price = $(this).data("price");
    let compare = $(this).data("compare");
    const compareFloat = Number(
      `${compare.split(",")[0]}.${compare.split(",")[1]}`
    );
    const priceFloat = Number(`${price.split(",")[0]}.${price.split(",")[1]}`);
    let save_price = (compareFloat - priceFloat).toFixed(2);

    $(this).parent().siblings(".save_price").find("span").html(save_price);
    const brand = $(this).attr("data-brand");
    const braq = $(this).attr("data-braq");

    if (price.split(",")[0] * 1 > 50) {
      $(this).parents(".product-box").find(".sp-brand3").show();
      $(this).parents(".product-box").find(".p-dingwei").show();
    } else {
      $(this).parents(".product-box").find(".sp-brand3").hide();
      $(this).parents(".product-box").find(".p-dingwei").hide();
    }

    // if(braq) {
    //   $(this).parents(".product-box").find("#sp-braq3").show();
    // } else {
    //   $(this).parents(".product-box").find("#sp-braq3").hide();
    // }
  });
  $(".sp-brand3").hide();
  // $("#sp-braq3").hide();

  // btn
  new Swiper("#swiper3", {
    // { direction: "vertical",
    spaceBetween: 20,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
  });

  // btn
  new Swiper("#swiperr4", {
    direction: "vertical",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
  });

  $(".sp_go_pro").on("click", function () {
    let ele = document.getElementById("mao");
    const offsetTop = ele.offsetTop - 110;
    window.scroll({
      top: offsetTop * $("div#root").css("zoom"),
      behavior: "smooth", // 使用 smooth 实现平滑滚动
    });
    // ele.scrollIntoView({
    //     behavior:'smooth'
    // })
  });

  $(".addGroup .reduce,.addGroup .add").on("click", function () {
    let num = parseInt($(this).siblings("input").val());
    if ($(this).hasClass("reduce")) {
      if (num > 1) {
        num--;
      }
    } else {
      num++;
    }
    $(this).siblings("input").val(num);
  });

  $(".sp_buy_now").on("click", function () {
    let id = $(this).siblings(".selectl").find("span.on").data("id");

    if ($(this).attr("data-num")) {
      id = $(this).siblings(".flex-bet").find("span.on").data("id");
    }
    window.location.href = "/cart/" + id + ":1";
  });

  let btns = document.getElementsByClassName("swiperbtn");
  // new Swiper("#nav1")
  let autoSwiper = new Swiper("#swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    on: {
      slideChangeTransitionStart: function () {
        if (this.activeIndex == 0) {
          btns[1].classList.remove("active");
          btns[0].classList.add("active");
        } else {
          btns[0].classList.remove("active");
          btns[1].classList.add("active");
        }
      },
    },
  });
  $("#checkBtn div").click(function () {
    let num = Number($(this).index());
    autoSwiper.slideTo(num);
  });

  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }

  function setupNewCountdown() {
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + 3);
  }

  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".hours").html(cutDownTimeText.hour);
      $(".minutes").html(cutDownTimeText.minute);
      $(".seconds").html(cutDownTimeText.second);
    }, 1000);
  }

  getCutDownTime();
});

jQuery("#nav-top").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 8,
  vis: 2,
});
